"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePerformanceMonitor = void 0;
const utilities_1 = require("../../utilities");
class DatePerformanceMonitor {
    constructor() {
        this._report = {
            runs: []
        };
        this._run = undefined;
    }
    checkpoint(log) {
        if (this._run) {
            this._run.checkpoints.push(Object.assign({ moment: Date.now() - this._run.start }, log));
        }
    }
    start(id) {
        if (this._run) {
            this._report.runs.push(this._run);
        }
        this._run = {
            id: id || utilities_1.Guid.next().toString(),
            start: Date.now(),
            checkpoints: [{
                    location: 'start',
                    moment: 0
                }]
        };
    }
    stop() {
        if (this._run) {
            this._run.stop = Date.now();
            this._run.checkpoints.push({
                location: 'stop',
                moment: this._run.stop - this._run.start
            });
            this._report.runs.push(this._run);
            this._run = undefined;
        }
    }
    clear() {
        this._run = undefined;
        this._report = {
            runs: []
        };
    }
    report() {
        return this._report;
    }
}
exports.DatePerformanceMonitor = DatePerformanceMonitor;
//# sourceMappingURL=date-performance-monitor.js.map